// event-bus.service.ts
import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

interface EventData {
  name: string;
  payload?: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private eventSubject = new Subject<EventData>();

  // Observable stream for event subscription
  private events$ = this.eventSubject.asObservable();

  // Method to emit an event
  emit(eventName: string, payload?: any) {
    console.log(`EventBusService: Emitting event: ${eventName}`);
    console.log('EventBusService: Payload:', payload);
    this.eventSubject.next({name: eventName, payload});
  }

  // Method to register for specific events
  register(eventName: string): Observable<any> {
    return this.events$.pipe(
      filter((event: any) => event.name === eventName),  // Filter events by name
      map((event: any) => event.payload)                 // Extract the payload
    );
  }

  registerRefreshMyBusiness() {
    return this.register('refreshMyBusiness');
  }

  emitRefreshMyBusiness() {
    this.emit('refreshMyBusiness');
  }
}
